// @flow
import React, { PureComponent, Fragment } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';
import { withRouter, Link } from 'react-router-dom';
import type { QuestionType, ThemeType } from 'types/Faq';
import Breadcrumb from 'components/fragments/Breadcrumb';
import FaqContent from 'containers/contact/FaqContentContainer';
import FaqThemeList from 'containers/contact/FaqThemeListContainer';
import Highlighter from 'react-highlight-words';
import { dynamicClassName } from 'utils/dynamicClassName';
import { getMetaBySlug } from 'utils/seoUtils';

export type StateProps = {
  themes?: Array<ThemeType>,
  questions: Array<QuestionType>,
  ligue: string
};

export type DispatchProps = {
  fetchThemes: () => void,
  fetchQuestions: () => void
};

type Props = {
  history: any,
  location: any
} & DispatchProps &
  StateProps;

type ComponentState = {
  text: string,
  validSearch: string
};

class FaqWrapper extends PureComponent<Props, ComponentState> {
  static defaultProps = {
    themes: []
  };
  state: ComponentState = {
    text: '',
    validSearch: ''
  };

  componentDidMount() {
    this.props.fetchThemes();
    if (this.props.questions.length === 0) {
      this.props.fetchQuestions();
    }
  }

  handleOnChange = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      this.setState({
        text: e.target.value
      });
    }
  };

  handleOnSubmit = (e: Event) => {
    e.preventDefault();
    this.props.history.replace('/faq');
    this.setState({
      validSearch: this.state.text,
      text: ''
    });
  };

  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location;

    if (prevProps.location.pathname !== pathname && pathname !== '/faq') {
      this.setState({
        validSearch: '',
        text: ''
      });
    }
  }

  renderSuggest = () => {
    const { questions, themes } = this.props;

    const filteredQuestions = questions.filter(question =>
      question.title.toLowerCase().includes(this.state.text.toLowerCase())
    );

    if (filteredQuestions.length === 0 || !themes || themes.length === 0) {
      return null;
    }

    // TODO : pass question id to FaqContent
    // https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#9-avoid-using-index-as-key-for-map
    return filteredQuestions.map(question => {
      const filteredTheme = themes.filter(theme => theme.id === question.theme);
      if (!filteredTheme[0]) {
        return null;
      }
      return (
        <li key={question.slug} className="ft-secondary mb-2">
          <Link to={`/faq/${filteredTheme[0].slug}/${question.slug}`}>
            <Highlighter searchWords={this.state.text.split(' ')} autoEscape={true} textToHighlight={question.title} />
          </Link>
        </li>
      );
    });
  };

  render() {
    const divClassName = dynamicClassName('col search-faq');
    this.state.text !== '' && divClassName.add('has-autocompletion');

    return (
      <Fragment>
        <section className="banner banner--big banner--faq">
          <div className="banner__thumbnail img-blue-100" style={{ backgroundImage: 'url()' }}></div>
          <div className="container">
            <Breadcrumb breadcrumbStyle="mt-3" elements={[{ name: 'Accueil', to: '/' }, 'FAQ']} isDark={true} />
            <h1 className="ft-h2">FAQ</h1>
            <p className="banner__desc">Comment pouvons-nous vous aider ?</p>
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className={divClassName.build()}>
              <div className="search-faq__wrapper">
                <div className="input input--search ">
                  <form onSubmit={this.handleOnSubmit}>
                    <input
                      type="search"
                      id="892hspdse"
                      placeholder="Posez votre question"
                      autoComplete="off"
                      onChange={this.handleOnChange}
                    />
                    <label htmlFor="892hspdse">Posez votre question</label>
                  </form>
                </div>
                <div className="search-faq__autocompletion">
                  <div>
                    <p className="ft-500 mb-1 mb-md-2">Suggestions</p>
                    <ul>{this.renderSuggest()}</ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-lg-8 mt-4">
            <div className="col col--center">
              <div className="box block-faq mb-5">
                <FaqThemeList validSearch={this.state.validSearch} />
                <FaqContent validSearch={this.state.validSearch} />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withHelmet(withRouter(FaqWrapper))((Helmet, pageProps) => {
  const meta = getMetaBySlug(pageProps.location.pathname);
  return (
    <Helmet>
      <title>{meta.title(pageProps.ligue)}</title>
      <meta name={'description'} content={meta.description()} />
      <meta property={'og:title'} content={meta.title(pageProps.ligue)} />
      <meta property={'og:description'} content={meta.description()} />
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
